"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeekdayRate = void 0;
const isWeekdayRate = (days, weekend_days) => {
    //get a list of the days that are flagged as weekend days
    const weekdays = Object.keys(weekend_days).filter((day) => {
        return weekend_days[day] === false;
    });
    // get a list of the days that are true in the days object
    const days_list = Object.keys(days).filter((day) => {
        return days[day] === true;
    });
    // if there is any overlap between the two lists, then return true
    const result = weekdays.some((day) => {
        return days_list.includes(day);
    });
    return result;
};
exports.isWeekdayRate = isWeekdayRate;
